import { ISymbol } from '@aqx-core/common/api/market';
import { IFavouriteWatchlistParams, IGetWatchlistParams } from '@aqx-core/common/api/watchlist';
import { request } from '@aqx-core/common/request';

type NewType = IFavouriteWatchlistParams;

export default {
  getWatchlistWithoutMiniChart: (params: IGetWatchlistParams, signal?: AbortSignal) =>
    request.get<ISymbol[]>('/api/market/watchlist/v1', { params, signal }),
  favouriteSymbol: (params: IFavouriteWatchlistParams) => request.post<boolean>('/api/market/watchlist/v1', params),
  unfavouriteSymbol: (params: NewType) => request.delete<boolean>('/api/market/watchlist/v1', { params }),
  getWatchlistWithMiniChart: (params: IGetWatchlistParams) =>
    request.get<ISymbol[]>('/api/market/watchlist/v1/symbols/category', { params })
};
